import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';
import SERVICE_API_URL from '../serviceUrl';

const useTestActions = () => {
  const navigate = useNavigate();

  const handleStartTest = (testId, status) => {
    // Use the correct route that exists in the application
    navigate(`/start-test/${testId}`);
  };

  const verifyPayment = async (response, orderId, test, onSuccess) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    try {
      const verificationResponse = await axios.post(
        `${SERVICE_API_URL}/prep/payment/verify-payment`,
        {
          orderId: orderId,
          testId: test.testId,
          paymentId: response.razorpay_payment_id,
          signature: response.razorpay_signature,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${idToken}`
          }
        }
      );

      const verificationData = verificationResponse.data;
      if (verificationData.status === "success") {
        // Call the onSuccess callback if provided
        if (onSuccess) {
          await onSuccess();
        }
        // Navigate directly to start test
        navigate(`/start-test/${test.testId}`);
      } else {
        alert("Payment verification failed!");
      }
    } catch (error) {
      console.error("Error verifying payment:", error);
      alert("Payment verification failed!");
    }
  };

  const handlePayment = async (test, onPaymentSuccess) => {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();

    try {
      const response = await axios.post(
        `${SERVICE_API_URL}/prep/payment/create-order`,
        null,
        {
          params: { testIdentifier: test.testId },
          headers: {
            "Authorization": `Bearer ${idToken}`
          }
        }
      );

      const orderData = response.data;
      if (orderData.status === "already-unlocked") {
        if (onPaymentSuccess) {
          await onPaymentSuccess();
        }
        navigate(`/start-test/${test.testId}`);
        return;
      }

      const order = orderData.order;
      if (!order) {
        throw new Error("Payment order was not returned by the backend");
      }
      const parsedOrder = JSON.parse(order);

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: parsedOrder.amount,
        currency: "INR",
        name: "BrainyHoot",
        description: test.testId,
        order_id: parsedOrder.id,
        handler: function (response) {
          verifyPayment(response, parsedOrder.id, test, onPaymentSuccess);
        },
//        prefill: {
//          name: "John Doe",
//          email: "johndoe@example.com",
//          contact: "9999999999",
//        },
        theme: {
          color: "#3399cc",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment failed:", error);
      alert("Payment failed! Try again.");
    }
  };

  return {
    handleStartTest,
    handlePayment,
    verifyPayment
  };
};

export default useTestActions; 
